<!-- <p>bins works!</p> -->

<p-table [value]="allBins" dataKey="id" [paginator]="true" [rows]="15">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th>Bin Counts</th>
        <th>Max. Qty</th>
        <th>Location Name</th>
        <th>Is Active</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-bin>
      <tr>
        <td>{{bin.name}}</td>
        <td>{{bin.type?bin.type.name:''}}</td>
        <td>{{bin.totalBins}}</td>
        <td>{{bin.warehouseBin && bin.warehouseBin.length>0 && bin.warehouseBin[0].capacity}}</td>
        <td>{{bin.warehouse?bin.warehouse.name:''}}</td>
        <td>{{bin.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
        <td class="action">
          <span class="btnBars p-mr-0" pTooltip="View" tooltipPosition="top">
            <i class="pi pi-file" (click)="showViewBinDetails(bin)"></i></span>
          <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i class="pi
            pi-pencil" (click)="checkBin(bin,'edit')"></i></span>
          <span class="btnBars p-mr-0" pTooltip="Delete"
            tooltipPosition="top"><i class="pi pi-trash" (click)="checkBin(bin,'delete')"></i></span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog header="Delete Bin" [(visible)]="displayBinAvailability" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="header">
    <h5>Delete Warning</h5>
  </div>
  <div class="card">
    <span style="font-weight: bold;">This Bin is associated with Multiple Products</span><br>
    <span>{{associatedProducts}}</span>
  </div>
</p-dialog>

<p-dialog header="{{binDetailHeader}}" [(visible)]="displayAddEditBinDetail" [modal]="true"
  [responsive]="true" [style]="{width: '60vw'}" (onHide)="cancelBinDialog()">
  <div class="header">
    <h5>Bin Details</h5>
  </div>
  <form [formGroup]="binForm">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12">
          <label>Location <span style="color: red;">*</span></label>
          <p-dropdown appendTo="body" [options]="allLocations" optionLabel="name"  [disabled]="!isAddBin"
          [ngModelOptions]="{standalone: true}"formControlName="warehouseId" placeholder="Select Location"></p-dropdown>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <label for="name">Name<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="name">
          <small *ngIf="invalidData" class="p-invalid">
            Name already exists.
          </small>
        </div>
        <div class="p-col-12 p-md-6">
          <label for="name">Max. Qty</label>
          <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false" [min]="0" formControlName="capacity"></p-inputNumber>
        </div>
      </div>
      <div class="p-grid">
          <div class="p-col-12 p-md-6" *ngFor="let type of binTypes;let i = index;">
            <div class="p-field-radiobutton p-mb-0">
              <p-radioButton name="details" [value]="type" [disabled]="!isAddBin" [(ngModel)]="selectedMode" (onClick)="getSection()" [ngModelOptions]="{standalone: true}" [inputId]="type.id"></p-radioButton>
              <label [for]="type.id">{{type.name}}</label>
            </div>
          </div>        
        <!-- <div class="p-col-12 p-md-6 p-mb-0">
          <div class="p-field-radiobutton">
            <p-radioButton name="details" value="Setup Wizard" formControlName="typeId" inputId="detail2"></p-radioButton>
            <label for="detail2">Wizard</label>
          </div>
        </div> -->
      </div>
      <div class="p-grid" *ngIf="selectedMode?.name == binTypeConstants[0]">
        <div class="p-col-2">
          <label>Bin Prefix<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="prefix" placeholder="Prefix" [readonly]="!isAddBin" [maxlength]="5"> 
        </div>
        <div class="p-col-4">
          <label>Starting Number<span style="color: red;">*</span></label>
          <input type="number" pInputText formControlName="number"  [readonly]="!isAddBin" (keypress)="isNumberKey($event)"> 
        </div>
        <div class="p-col-6">
          <label>Bin counts to be created<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="count"  [readonly]="!isAddBin" (keypress)="isNumberKey($event)"> 
        </div>
      </div>
     
      <ng-container *ngIf="selectedMode?.name == binTypeConstants[1]">
        <div class="p-grid p-jc-end">
          <div class="p-col-1">
            <p-dropdown [options]="separators" formControlName="seperator" optionLabel="name" 
            [ngModelOptions]="{standalone: true}" appendTo="body" class="small" [disabled]="!isAddBin"></p-dropdown>
          </div>
        </div>
          <ng-container *ngFor="let s of setupWizard; let i = index;">
            <div class="p-field p-formgrid p-grid">
              <div class="p-col-1 p-offset-1">
                <label>Level{{i + 1}}</label>
              </div>
              <div class="p-col-3 p-pl-4">
                <input type="text" pInputText [(ngModel)]="s.level" [disabled]="!isAddBin" name="level{{i}}" #level="ngModel"  class="small" style="width: 80% !important;" [ngModelOptions]="{standalone: true}"> 
                <span pTooltip="{{s.description}}" tooltipPosition="top" class="pi pi-info-circle"></span>
              </div>
              <div class="p-col-2">
                <p-inputNumber (keypress)="isNumberKey($event)" [disabled]="!isAddBin" [(ngModel)]="s.number" name="wizardNumber{{i}}"  #wizardNumber="ngModel"  inputId="minmax" [min]="0" [max]="(setupWizard.length-1)!=i? 5:9999" [ngModelOptions]="{standalone: true}"></p-inputNumber>
              </div>
              <!-- <div class="p-col-2" *ngIf="s.code == 'bins'">
                <p-inputNumber (keypress)="isNumberKey($event)" [disabled]="!isAddBin" [(ngModel)]="s.number" name="wizardNumber{{i}}"  #wizardNumber="ngModel" inputId="minmax" [max]="999" [ngModelOptions]="{standalone: true}"></p-inputNumber>
              </div> -->
              <div class="p-col-2">
                <input type="text" pInputText placeholder="Prefix" [disabled]="!isAddBin" [(ngModel)]="s.prefix" #wizardPrefix="ngModel" name="wizardPrefix{{i}}" [maxlength]="5" [ngModelOptions]="{standalone: true}"> 
              </div>
              <div class="p-col-2">
                <span class="btnBars" style="position: relative;" *ngIf="setupWizard.length > 1 && isAddBin"
                (click)="removeLevel(i)">
                  <i class="pi pi-trash"></i>
                </span>
                <span class="btnBars" style="position: relative;" *ngIf="setupWizard.length == (i+1) && 4 > setupWizard.length && isAddBin"
                (click)="addLevel()">
                  <i class="pi pi-plus"></i>
                </span>  
              </div>
            </div>
          </ng-container>
      </ng-container>
    </div>
    <span class="p-text-center" *ngIf="addValidation" style="color: red;">{{errorMsg}}.</span>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayAddEditBinDetail=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton label="Save" [disabled]="!binForm.valid" (click)="nextBinNumberList(binForm.value)"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Bin Numbering List" [(visible)]="displayBinNumberList" [modal]="true" [responsive]="true"
  [style]="{width: '45vw'}">
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12">
          <p-table [value]="numberList" editMode="row" dataKey="id" [paginator]="true" [rows]="15">
            <!-- <ng-template pTemplate="caption">
              <div class="p-text-right">
                  <p-button icon="pi pi-download" class="p-mr-2"></p-button>
                  <p-button icon="pi pi-print"></p-button>
              </div>
            </ng-template> -->
            <ng-template pTemplate="header">
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th style="width: 2rem;">
                  <p-checkbox binary="true" [(ngModel)]="headerCheck" [ngModelOptions]="{standalone: true}" 
                  (onChange)="selectDeselectAllLists(list.checked)" #list *ngIf="!viewMode"></p-checkbox>
                </th>
                <th style="width: 4rem"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-i="rowIndex">
              <tr>
                <td>{{i+1}}</td>
                <td pEditableColumn class="action">
                  {{product.name}}
                </td>
                <td>
                  <p-checkbox *ngIf="!viewMode" [value]="product" [(ngModel)]="product.checked" binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                </td>
                <td class="action">
                  <span class="btnBars p-mt-0" *ngIf="product.checked && !viewMode" (click)="deleteSingleBin(i)"><i class="pi pi-trash"></i></span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  <p-footer>
    <button *ngIf="!viewMode" type="button" pButton (click)="backToBinDetail()" label="Back"></button>
    <button type="button" pButton (click)="displayBinNumberList=false" label="Cancel" class="p-button-secondary"></button>
    <button *ngIf="!viewMode" type="button" pButton label="Save" (click)="save(numberList)"></button>
  </p-footer>
</p-dialog>